
namespace RecordShield.Workspace {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    export class KeyGenAsDialog extends Serenity.EntityDialog<KeyGenAsRow, any> {
        protected getFormKey() { return KeyGenAsForm.formKey; }
        protected getIdProperty() { return KeyGenAsRow.idProperty; }
        protected getLocalTextPrefix() { return KeyGenAsRow.localTextPrefix; }
        protected getNameProperty() { return KeyGenAsRow.nameProperty; }
        protected getService() { return KeyGenAsService.baseUrl; }

        protected form = new KeyGenAsForm(this.idPrefix);

        constructor() {
            super();
            this.form.Product.changeSelect2(e => {
                var productId = this.form.Product.value.toString();
                if (Q.isEmptyOrNull(productId)) {
                    this.setProductDetails({});
                    return;
                }
                if (this.form.Quantity.value == null)
                {
                    Q.alert("Please enter Quantity");
                    this.form.Product.value = null;
                    return;
                }
              //  var id = Q.first(Workspace.ProductsRow.getLookup().items, x => x.Id.toString() == productId).Id;
                Workspace.ProductsService.Retrieve({
                    EntityId: productId
                }, response => {
                    this.setProductDetails(response.Entity);
                });
            });
            this.form.Quantity.change(e => {
                debugger;
                var productId = this.form.Product.value.toString();
                if (Q.isEmptyOrNull(productId) == false) {
                    Workspace.ProductsService.Retrieve({
                        EntityId: productId
                    }, response => {
                        this.setProductDetails(response.Entity);
                    });

                }


            });
        }

        loadEntity(entity: KeyGenRow) {
            super.loadEntity(entity);

            if (this.isNew) {
                this.form.Status.value = "2";
                Serenity.EditorUtils.setReadonly(this.form.Status.element, true);
            }
            else
                Serenity.EditorUtils.setReadonly(this.form.Status.element, false);
            this.form.AccessStatus.changeSelect2(e => {
                this.showHidePaymentModeInfo();
            });
            this.showHidePaymentModeInfo();

        }

        protected validateBeforeSave() {
            var isValidate = super.validateForm();
            if (isValidate) {
                isValidate = super.validateBeforeSave();
            }
            if (this.form.TotalAllowedDuration.value == 0) {
                Q.alert("Total Allowed Duration cannot be Zero.");
                return false;
            }
            return isValidate;
        }

        showHidePaymentModeInfo() {
            if (this.form.AccessStatus.value != null) {
                var isChk = (this.form.AccessStatus.value == "2");
                this.form.SerialKeyItems.getGridField().toggle(isChk);
                if (isChk) {
                    this.form.SerialKeyItems.value = "";
                    Serenity.EditorUtils.setRequired(this.form.SerialKeyItems, true);

                }


            }
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            //Serenity.EditorUtils.setReadonly(this.form.ValidityInDays.element, true);
            //Serenity.EditorUtils.setReadonly(this.form.Views.element, true);
            //Serenity.EditorUtils.setReadonly(this.form.WatchTime.element, true);
        }

        private setProductDetails(details: Workspace.ProductsRow) {
            debugger;
            //this.form.Views.value = details.Views;
            //this.form.WatchTime.value = details.WatchTime;
            ////this.form.ValidityInDays.value = details.ValidityInDays;
            //this.form.FreeTrial.value = details.FreeTrial;
            //this.form.FreeTrialCredits.value = details.FreeTrialCredits;
            //this.form.WantAnalytics.value = details.WantAnalytics;
            this.form.UpdateFrequencyInDays.value = details.UpdateFrequencyInDays;
            this.form.AllowSecondScreen.value = details.AllowSecondScreen;
            if (details.eViews != null)
                this.form.eViews.value = details.eViews.toString();
            else
                this.form.eViews.value = null;
            if (details.eWatchTime != null)
                this.form.eWatchTime.value = details.eWatchTime.toString();
            else
                this.form.eWatchTime.value = null;
            if (details.eValidity != null)
                this.form.eValidity.value = details.eValidity.toString();
            else
                this.form.eValidity.value = null;
           
            this.form.Status.value = "2";
            this.form.Size.value = details.Size;
            var Quantity = this.form.Quantity.value;
            this.form.Credit.value = details.Credit * Quantity;
            this.form.TotalAllowedDuration.value = details.TotalAllowedDuration;
            if (details.UserId != null)
                this.form.Owner.value = details.UserId.toString();
            else {
                this.form.Owner.value = null;
                this.form.Credit.value = null;
                this.form.Quantity.value = null;
            }
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            return buttons;
        }
    }
}